<template>
  <div class="setting-main-container">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('customers.shipping_address') }}</h3>
        </div>
        <div class="row">
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('customers.name') }}</label>
            <p v-if="viewCustomer && viewCustomer.shipping_address && viewCustomer.shipping_address.name !=null">{{ viewCustomer.shipping_address.name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('customers.country') }}</label>
            <p v-if="viewCustomer && viewCustomer.shipping_address && viewCustomer.shipping_address.country !=null">{{ viewCustomer.shipping_address.country.name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('customers.state') }}</label>
            <p v-if="viewCustomer && viewCustomer.shipping_address && viewCustomer.shipping_address.state !=null">{{ viewCustomer.shipping_address.state }}</p>
          </div>
           <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('customers.city') }}</label>
            <p v-if="viewCustomer && viewCustomer.shipping_address && viewCustomer.shipping_address.city !=null">{{ viewCustomer.shipping_address.city }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('general.street_1') }}</label>
            <p v-if="viewCustomer && viewCustomer.shipping_address && viewCustomer.shipping_address.address_street_1 !=null">{{ viewCustomer.shipping_address.address_street_1 }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('general.street_2') }}</label>
            <p v-if="viewCustomer && viewCustomer.shipping_address && viewCustomer.shipping_address.address_street_2 !=null">{{ viewCustomer.shipping_address.address_street_2 }}</p>
          </div>
          
         
           <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('customers.phone') }}</label>
            <p v-if="viewCustomer && viewCustomer.shipping_address && viewCustomer.shipping_address.phone !=null">{{ viewCustomer.shipping_address.phone }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('customers.zip_code') }}</label>
            <p v-if="viewCustomer && viewCustomer.shipping_address && viewCustomer.shipping_address.zip !=null">{{ viewCustomer.shipping_address.zip }}</p>
          </div>
        </div>
      </div>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions,mapGetters } from 'vuex'
const { required, email, maxLength, numeric } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
        isLoading: false,
    }
  },
  computed: {
    ...mapGetters('customer', [
      'viewCustomer'
    ]),
  }, 
  created() {
  },
  validations: {},
  mounted () {},
  methods: {}
}
</script>
